module.exports = __webpack_public_path__ + "img/whatsapp.68374502.png";